import { BillingBlockReason } from 'types';

import { api } from './api';

export interface BillingBlockSettings {
  reasons: BillingBlockReason[];
}

export interface AddBillingBlocksRequest {
  accountIds: string[];
  reason: string;
  notes: string;
  expiresAt?: string;
}

export interface RemoveBillingBlocksRequest {
  accountIds: string[];
  reason: string;
  notes: string;
}

export interface AccountFailedToBlock {
  accountId: string;
  reason: string;
}

export interface AddBillingBlocksResponse {
  completedAccounts: string[];
  invalidAccounts: AccountFailedToBlock[];
  accountsAlreadyBlocked: string[];
  accountsWithFirstPaymentDueDate: string[];
}

export interface RemoveBillingBlocksResponse {
  completedAccounts: string[];
  invalidAccounts: AccountFailedToBlock[];
  accountsWithNoBlocks: string[];
}

export const billingBlocksApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBillingBlockSettings: build.query<BillingBlockSettings, void>({
      query: () => ({
        url: '/admin/billing-blocks/settings',
        method: 'GET',
      }),
    }),
    addBillingBlocks: build.mutation<AddBillingBlocksResponse, AddBillingBlocksRequest>({
      query: (body) => ({
        url: '/admin/billing-blocks/add',
        method: 'POST',
        body,
      }),
    }),
    removeBillingBlocks: build.mutation<RemoveBillingBlocksResponse, RemoveBillingBlocksRequest>({
      query: (body) => ({
        url: '/admin/billing-blocks/remove',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetBillingBlockSettingsQuery, useAddBillingBlocksMutation, useRemoveBillingBlocksMutation } =
  billingBlocksApi;
